import { asyncThunkWrapper } from "../utils/asyncThunkWrapper";
import store from "../config/configureStore";
import { serviceNames } from "../utils/constants";

const initialState = {
  agencies: [],
  loading: false,
  error: null,
};

const FETCH_AGENCIES_REQUEST = "FETCH_AGENCIES_REQUEST";
const FETCH_AGENCIES_SUCCESS = "FETCH_AGENCIES_SUCCESS";
const FETCH_AGENCIES_FAILURE = "FETCH_AGENCIES_FAILURE";

export const fetchAgencies = () => async (dispatch) => {
  const client = store.store.getState().websocket.websocket;
  if (client) {
    const service = client.service(serviceNames.ptsAgencies);
    service.timeout = 200000;

    const query = {
      $select: ["AgencyID", "AgencyType"],
      IsDeleted: false,
      // AgencyType: '1',
      $limit: 0,
    };

    return await asyncThunkWrapper({
      dispatch,
      types: {
        request: FETCH_AGENCIES_REQUEST,
        success: FETCH_AGENCIES_SUCCESS,
        failure: FETCH_AGENCIES_FAILURE,
      },
      apiCall: () => service.find({ query }),
      transformResult: (result) => result,
      errorMessagePrefix: "Failed to fetch agencies",
    });
  }
};

export default function ptsAgencyReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_AGENCIES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_AGENCIES_SUCCESS:
      return { ...state, loading: false, agencies: action.payload };

    case FETCH_AGENCIES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
